import BaseAPI from "../api";

const path: string = "plans";

export interface createPlanType {
  planNo: string;
  planName: string;
  planStatus: string;
}
export interface getPlansType {
  keyword?: string;
  limit?: number;
  page?: number;
}
export interface updatePlaneType{
    planNo: string;
    planName: string;
    planStatus: string;
}

export class PlanApi extends BaseAPI {
  public static createPlans(props: createPlanType): Promise<any> {
    return this.api.post(`${path}`, props).then((res) => res).then(res => res)
  }
  public static getPlans(props: getPlansType): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then(res => res)
  }
  public static updatePlan(idPlan:number,props:updatePlaneType):Promise<any>{
    return this.api.patch(`${path}/${idPlan}`,props).then(res => res)
  }
  public static getDetailPlan(idPlan:number):Promise<any>{
    return this.api.get(`${path}/${idPlan}`).then(res => res);
  }
}
